import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { switchEndpoint } from "../../../../../redux/actions/endpoints";
import { storage } from "../../../../../scopedStorage";

// Amending is only allowed while a request is still pending — once HOP has
// reviewed it, the figure is locked in as what the admin pays out.
const EditModal = ({ show, onHide, request, onAmended }) => {
  const [form, setForm] = useState({ amount: "", reason: "" });
  const [submitting, setSubmitting] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});

  useEffect(() => {
    if (show && request) {
      setForm({ amount: request.amount || "", reason: request.reason || "" });
      setFieldErrors({});
    }
  }, [show, request]);

  const token = storage.getItem("token");
  const authHeaders = { Authorization: `Bearer ${token}` };

  const isValid = () => Number(form.amount) >= 0.01;

  const handleSubmit = async () => {
    if (!isValid() || !request) return;
    setSubmitting(true);
    setFieldErrors({});
    try {
      const { data } = await axios.patch(
        `${switchEndpoint}/aggregation-center/center-float-requests/${request.id}`,
        {
          amount: Number(form.amount),
          reason: form.reason.trim() || undefined,
        },
        { headers: authHeaders }
      );
      toast.success("Float request updated", {
        position: "top-right",
        autoClose: 3000,
        theme: "light",
      });
      onAmended(data);
    } catch (error) {
      const response = error?.response;
      if (response?.status === 422) {
        setFieldErrors(response.data?.errors || {});
      }
      toast.error(response?.data?.message || "The request could not be updated.", {
        position: "top-right",
        autoClose: 4000,
        theme: "light",
      });
    }
    setSubmitting(false);
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: 16 }}>
          Amend Float Request {request?.reference_no ? `— ${request.reference_no}` : ""}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form.Group style={{ marginBottom: 14 }}>
          <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>
            Amount (₦) <span style={{ color: "#ef4444" }}>*</span>
          </Form.Label>
          <Form.Control
            type="number"
            min={0.01}
            step="0.01"
            value={form.amount}
            onChange={(e) => setForm((prev) => ({ ...prev, amount: e.target.value }))}
            size="sm"
            isInvalid={!!fieldErrors.amount}
          />
          {fieldErrors.amount && (
            <Form.Text style={{ color: "#dc2626" }}>{fieldErrors.amount[0]}</Form.Text>
          )}
        </Form.Group>

        <Form.Group style={{ marginBottom: 4 }}>
          <Form.Label style={{ fontSize: 13, color: "#6b7280" }}>Reason</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            size="sm"
            maxLength={2000}
            value={form.reason}
            onChange={(e) => setForm((prev) => ({ ...prev, reason: e.target.value }))}
            isInvalid={!!fieldErrors.reason}
          />
          {fieldErrors.reason && (
            <Form.Text style={{ color: "#dc2626" }}>{fieldErrors.reason[0]}</Form.Text>
          )}
          <Form.Text style={{ color: "#9ca3af" }}>{form.reason.length}/2000</Form.Text>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onHide} size="sm" disabled={submitting}>
          Cancel
        </Button>
        <Button variant="dark" onClick={handleSubmit} size="sm" disabled={!isValid() || submitting}>
          {submitting ? "Saving..." : "Save Changes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditModal;
